import script from "./online-control-zone.vue?vue&type=script&lang=ts&setup=true"
export * from "./online-control-zone.vue?vue&type=script&lang=ts&setup=true"

import "./online-control-zone.vue?vue&type=style&index=0&id=34bb56cf&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bb56cf"]])

export default __exports__